import { v4 as uuid } from 'uuid';
import { toUUID } from '../../util/transform';
import { TicketLoanFeeType } from './TicketLoanFee.enum';
import type { ITicketLoanFee } from './TicketLoanFee.interface';

export default class TicketLoanFee implements ITicketLoanFee {
  id: string;
  name: string;
  amount: number;
  feeType: TicketLoanFeeType;
  isGstVatApplicable: boolean;

  static build = (data: ITicketLoanFee) => new TicketLoanFee(data);
  static blank = (feeType) => new TicketLoanFee({ id: uuid(), feeType });

  /**
   * Constructor
   * @param {ITicketLoanFee} data
   */
  constructor(data?: ITicketLoanFee) {
    this.id = toUUID(data?.id) || uuid();
    this.name = data?.name || '';
    this.amount = parseFloat(data?.amount || 0);
    this.feeType = TicketLoanFeeType.of(data?.feeType.name || data?.feeType.id);
    this.isGstVatApplicable = data?.isGstVatApplicable === true;
  }
}
